export const faqs = [
  {
    question: '「裙子下面是野兽」这个名字的由来是什么？',
    answer: '这个名字源于对女性多元气质的深刻理解——每一位女性在优雅的外表之下，都潜藏着一股不可忽视的野性力量。我们相信，真正的魅力来自于这种矛盾与张力：温柔与强势、优雅与不羁、柔软与坚硬，两者并存才构成了完整的女性之美。',
  },
  {
    question: '这个品牌的核心理念是什么？',
    answer: '我们的核心理念是「双重解放」：解放外在的穿搭束缚，也解放内在的精神桎梏。我们鼓励每一位女性打破社会对「女性气质」的刻板定义，在优雅与野性之间找到属于自己的平衡点，用穿搭表达真实的自我。',
  },
  {
    question: '你们的风格适合什么样的女性？',
    answer: '「裙子下面是野兽」不属于某一种类型的女性——它属于所有不愿被定义的女性。无论你是职场精英、艺术家、创业者还是全职妈妈，只要你的内心有一头不愿被驯服的野兽，这里就是你的精神家园。',
  },
  {
    question: '如何在日常穿搭中体现「野性」？',
    answer: '野性不一定要通过夸张的元素来表达。在日常穿搭中，你可以从小细节入手：一件动物纹的丝巾、一双铆钉装饰的平底鞋、一件不对称剪裁的上衣，甚至是一抹大胆的唇色，都能让你的优雅造型注入一丝不驯的力量。',
  },
  {
    question: '你们会推出实体产品吗？',
    answer: '我们目前是一个专注于时尚理念、风格宣言和穿搭哲学的内容平台。未来我们计划与独立设计师合作推出限量系列，敬请期待。你可以关注我们的社交媒体获取最新动态。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '陈雅琳',
    role: '品牌策划师',
    content: '「裙子下面是野兽」完全改变了我对穿搭的理解。以前总觉得自己必须在「温柔」和「强势」之间二选一，现在我发现两者可以共存，而且共存的时候才是最有力量的。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20woman%20with%20confident%20expression%2C%20warm%20natural%20lighting%2C%20cream%20minimalist%20background%2C%20editorial%20portrait%20photography%2C%20soft%20and%20elegant&width=120&height=120&seq=testimonial-1&orientation=squarish',
  },
  {
    id: 2,
    name: '王思涵',
    role: '独立设计师',
    content: '作为一个每天都在和面料打交道的设计师，这个平台给了我太多灵感。那些关于材质的讨论、关于结构的分析，每次读完都让我迫不及待想要开始新的创作。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20woman%20with%20creative%20artistic%20style%2C%20warm%20studio%20lighting%2C%20cream%20minimalist%20background%2C%20editorial%20portrait%20photography%2C%20elegant%20sophisticated&width=120&height=120&seq=testimonial-2&orientation=squarish',
  },
  {
    id: 3,
    name: '刘若曦',
    role: '金融分析师',
    content: '金融行业对女性的着装有着太多的隐性规则。感谢这个平台让我意识到，我可以在遵守职场礼仪的同时，保留自己的风格态度。现在的我，在会议室里既有温柔的说服力，也有不可撼动的底气。',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20woman%20in%20business%20attire%2C%20warm%20natural%20lighting%2C%20cream%20minimalist%20background%2C%20editorial%20portrait%20photography%2C%20confident%20professional%20look&width=120&height=120&seq=testimonial-3&orientation=squarish',
  },
];